import React, { useEffect, useState } from "react";
import "../general.css";
import logo from "../assets/logo.png";
import Loading from "../Pages/Loading";
// import { useNavigate } from "react-router-dom";
import navigation from "../Auth/Navigation";

const StaffHomePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const navigation = useNavigate();
  const year = () => {
    let VarDate = new Date().getFullYear();
    return VarDate;
  };

  const Staff_Name = () => {
    return sessionStorage.getItem("Username");
  };

  useEffect(() => {
    if (sessionStorage.getItem("Username") === null) {
      navigation("/");
    } else {
      sessionStorage.setItem("MainHome", sessionStorage.getItem("MainHome"));
    }
  }, []);

  const Logout = () => {
    setIsLoading(true);
    sessionStorage.clear();
    localStorage.clear();
    navigation("/");

    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const set_Flow = () => {
    setIsLoading(true);
    navigation("/Non-Acc-Staff-Home/SetWorkFlow");

    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const Get_Status = (StatusType) => {
    sessionStorage.setItem("StatusType", StatusType);
    sessionStorage.setItem("MainHome", "Non-Acc-Staff-Home");
    navigation("/Non-Acc-Staff-Home/Status");
  };

  return (
    <div className="main">
      {isLoading && <Loading />}
      <div className="Background">
        <div className="Header">
          <img src={logo} alt="University Logo" className="Logo" />
          <div className="title">VIT Document Approval System</div>
        </div>
        <div className="Main-Background">
          <div className="Content-Background">
            <div className="welcome-with-Logout-button">
              <div className="Welcome-Name">Welcome {Staff_Name()}</div>
              <button className="logout-button" onClick={Logout}>
                <span className="logout-icon">🚪</span>
                <span>Sign Out</span>
              </button>
            </div>

            <div className="buttons-sets-home">
              <button className="buttons-hover" onClick={set_Flow}>
                Create Document Flow Path
              </button>
              <button
                className="buttons-hover"
                onClick={() => Get_Status("New Requests")}
              >
                New Requests <i className="Status Color-Green"></i>
              </button>
              <button
                className="buttons-hover"
                onClick={() => Get_Status("Approved Requests")}
              >
                Approved Requests<i className="Status Color-Blue"></i>
              </button>
              <button
                className="buttons-hover"
                onClick={() => Get_Status("Rejected Requests")}
              >
                Rejected Requests<i className="Status Color-Red"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-credit" style={{textAlign: 'center', marginTop: '2rem', color: '#64748b', fontWeight: 500}}>
        Developed by GARV ANAND
      </div>
    </div>
  );
};

export default StaffHomePage;
